import { useSnapshot } from 'hooks/use-safe-snapshot';
import { state } from 'state/current-project';

const useCurrentProject = () => {
    const { project } = useSnapshot(state);

    return project;
};

export { useCurrentProject };
